import { FEATURE_NAME } from './constants'
import { GlobalState } from './reducer'
import { createSelector } from 'reselect'

const select = (state: GlobalState) => state[FEATURE_NAME]

export const getUserAccessToken = createSelector(select, state => state.userAccessToken)
export const getUserAccount = createSelector(select, state => state.userAccount)
